var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "close_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"
  })));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHRpdGxlPkNsb3NlPC90aXRsZT48cGF0aCBkPSJNMjg5Ljk0IDI1Nmw5NS05NUEyNCAyNCAwIDAwMzUxIDEyN2wtOTUgOTUtOTUtOTVhMjQgMjQgMCAwMC0zNCAzNGw5NSA5NS05NSA5NWEyNCAyNCAwIDEwMzQgMzRsOTUtOTUgOTUgOTVhMjQgMjQgMCAwMDM0LTM0eiIvPjwvc3ZnPg==";